module.exports = __webpack_public_path__ + "static/media/bgTotalQuestionPost.4cdc07d9.svg";